import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { Box, Divider, Skeleton } from '@mui/material';

const CartItemShimmer = () => (
	<FlexBox justifyContent={'space-between'} p='32px'>
		<FlexBox width='80%' alignItems={'center'}>
			<Skeleton
				width={113}
				height={77}
				variant='rounded'
				sx={{ mr: '16px' }}
			></Skeleton>
			<Box width='100%'>
				<Skeleton></Skeleton>
				<Skeleton width={'40%'} sx={{ mt: '12px' }}></Skeleton>
				<Skeleton width={'30%'} sx={{ mt: '12px' }}></Skeleton>
			</Box>
		</FlexBox>
	</FlexBox>
);

const CartListShimmer = () => {
	return (
		<Box
			mb={'24px'}
			sx={{
				borderRadius: '18px',
				border: '1px solid #E8E8E8',
				overflow: 'hidden',
			}}
		>
			<FlexBox
				p='24px 32px'
				sx={{ backgroundColor: getColor('Gray -6') }}
				alignItems='center'
			>
				<Skeleton height={20} width={'10%'} sx={{ mr: '10px' }} />
				<Skeleton height={14} width={'10%'} />
			</FlexBox>
			<CartItemShimmer />
			<Divider />
			<CartItemShimmer />
			<Divider />
			<CartItemShimmer />
		</Box>
	);
};

export default CartListShimmer;
